// src/components/User/PrivacyPolicy.js
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';

export default function PrivacyPolicy() {
    return (
        <>
            <Helmet>
                <title>Privacy Policy | Anindya Chowdhury</title>
                <meta
                    name="description"
                    content="Privacy Policy for anindyachowdhury.com - Information handling and privacy practices."
                />
            </Helmet>

            <Header />

            <main
                className="px-6 md:px-12 lg:px-36 py-16 max-w-4xl mx-auto leading-relaxed"
                style={{ color: 'var(--text-primary)' }}
            >
                <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">
                    Privacy Policy
                </h1>
                <p className="text-sm mb-10" style={{ color: 'var(--text-secondary)' }}>
                    Effective Date: September 15, 2026
                </p>

                <div className="space-y-8 text-base md:text-[1.05rem]" style={{ color: 'var(--text-secondary)' }}>
                    <p>
                        This Privacy Policy explains how Anindya Chowdhury (“I”, “me”, or “my”) collects and uses information when you visit anindyachowdhury.com (the “Website”) or contact me through the Website.
                    </p>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Information I Collect
                        </h2>
                        <p className="mb-3">
                            I may collect information that you voluntarily provide, including:
                        </p>
                        <ul className="list-disc pl-6 space-y-1.5">
                            <li>Your name</li>
                            <li>Email address</li>
                            <li>Business or company name</li>
                            <li>Information you provide in the contact form, including details about the growth problem or business decision you are considering</li>
                        </ul>
                        <p className="mt-4">
                            The Website may also automatically collect limited technical information such as browser type, device information, approximate location, pages visited, and other usage information through analytics or similar technologies.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            How I Use Information
                        </h2>
                        <p className="mb-3">
                            Information may be used to:
                        </p>
                        <ul className="list-disc pl-6 space-y-1.5">
                            <li>Respond to enquiries and requests</li>
                            <li>Understand your business requirements before a conversation</li>
                            <li>Schedule or conduct consulting discussions</li>
                            <li>Improve the Website and its content</li>
                            <li>Understand Website traffic and usage</li>
                            <li>Maintain security and prevent misuse</li>
                        </ul>
                        <p className="mt-4 font-medium" style={{ color: 'var(--text-primary)' }}>
                            I do not sell your personal information.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Analytics and Third-Party Services
                        </h2>
                        <p>
                            The Website may use third-party services for analytics, scheduling, email delivery, hosting, or other website functionality. These providers may process information according to their own privacy policies. Where third-party services are used, their respective terms and privacy policies may also apply.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            How Long I Keep Information
                        </h2>
                        <p>
                            I retain information only for as long as reasonably necessary for the purposes described above, including responding to enquiries, maintaining business records, complying with legal obligations, or resolving disputes.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Data Security
                        </h2>
                        <p>
                            I take reasonable measures to protect information submitted through the Website. However, no method of transmission or storage is completely secure, and I cannot guarantee absolute security.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Your Choices
                        </h2>
                        <p>
                            You may contact me to request access to, correction of, or deletion of personal information you have provided, subject to applicable legal requirements.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Changes to This Policy
                        </h2>
                        <p>
                            I may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                        </p>
                    </div>

                    <div className="pt-6 border-t border-[rgba(0,0,0,0.08)]">
                        <h2 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                            Contact
                        </h2>
                        <p className="mb-2">For privacy-related questions or requests:</p>
                        <p className="font-semibold" style={{ color: 'var(--text-primary)' }}>
                            Anindya Chowdhury
                        </p>
                        <p>
                            Email:{' '}
                            <a
                                href="mailto:anindya@buzztobrand.com"
                                className="font-medium hover:underline"
                                style={{ color: 'var(--color-primary)' }}
                            >
                                anindya@buzztobrand.com
                            </a>
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}
